import { render, staticRenderFns } from "./home.view.vue?vue&type=template&id=45c3f26e&"
import script from "./home.view.vue?vue&type=script&lang=ts&"
export * from "./home.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports